"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBarExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const StepTypes_1 = require("../../Enum/StepTypes");
const configs_1 = require("../../configs/configs");
class ProgressBarExtension extends WidgetExtensionPlugin_1.default {
    initialize(widget) {
        return Promise.resolve().then(() => {
            this.widget = widget;
            this.widget.getEventContainer()
                .on(WidgetEvents_1.WidgetEvents.STEP_READY, this.setProgressBar.bind(this));
        });
    }
    setProgressBar() {
        let stepId = this.widget.getState().getStepId();
        let stepIndex = this.widget.getState().getStepIndex();
        let progressBar = this.widget.getContainer().querySelector(`[data-px-progress-active]`);
        if (StepTypes_1.StepTypes.ERROR === stepId.toString()) {
            stepIndex = this.previousStepIndex;
        }
        else {
            const stepDefinition = this.widget.getCurrentStep().getDefinition().rawDefinition;
            stepIndex = typeof stepDefinition.progressIndex === 'number' ? stepDefinition.progressIndex : stepIndex;
        }
        this.previousStepIndex = stepIndex;
        progressBar.style.width = Math.min((stepIndex / configs_1.configs.numberOfSteps * 100), 100).toString() + "%";
    }
}
exports.default = ProgressBarExtension;
exports.ProgressBarExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "progress_bar",
    class: ProgressBarExtension
});
